import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { Header } from "src/components/Header";
import { MobHeader } from "src/components/MobHeader";
import { Logo } from "src/components/Logo";
import { Search } from "src/components/Search";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { bannerTrns } from "../trns";
import { bannerParagraphs } from "./constants";

const DEFAULT_PARAGRAPHS_CLASSNAME =
  "text-purple-base lg:text-22 gl:text-xl text-justify font-light";

export const Banner = () => {
  const { t } = useTranslation();

  const isMDScreenBreakpoint = useMediaQuery({
    minWidth: SCREEN_BREAKPOINTS.MD,
  });

  return (
    <div
      className={cn("bg-cover bg-center bg-no-repeat", {
        "bg-home-banner": isMDScreenBreakpoint,
        "bg-home-banner-mobile": !isMDScreenBreakpoint,
      })}
    >
      <Header />
      <MobHeader />
      <div className="flex items-center justify-center mt-5 gl:hidden">
        <Logo isColored />
      </div>
      {/* lg:pt-52 gl:pt-72 */}
      <div className="container flex flex-col items-center justify-center gap-10 pt-40 pb-10 md:pt-30 lg:pt-40">
        <h1
          className="text-purple-base text-20 md:text-2xl lg:text-4xl xl:text-52 xl:leading-1.5 text-center"
          dangerouslySetInnerHTML={{ __html: t(bannerTrns.title) }}
        />

        <Search />

        <p className={DEFAULT_PARAGRAPHS_CLASSNAME}>
          {t(bannerTrns.description)}
        </p>

        <div className="flex flex-col gap-5 lg:px-20">
          {bannerParagraphs.map((paragaph) => (
            <p className={DEFAULT_PARAGRAPHS_CLASSNAME} key={paragaph.id}>
              {t(paragaph.text.i18nKey)}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
